var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useState, useMemo } from "react";
import { useForm } from "react-hook-form";
import { useIntl } from "react-intl";
import { zodResolver } from "@hookform/resolvers/zod";
import { createTitleVerificationSchema, } from "../utils/validationUtils";
import { usePublishersData } from "./usePublishersData";
import { formatPublisherLabel } from "../utils/publisherLabel";
export var useTitleVerificationForm = function (_a) {
    var initialValues = _a.initialValues;
    var formatMessage = useIntl().formatMessage;
    var _b = useState(initialValues.publisherNameToCheck || ""), publisherQuery = _b[0], setPublisherQuery = _b[1];
    var _c = useState(initialValues.ownerId || ""), selectedPublisherId = _c[0], setSelectedPublisherId = _c[1];
    var _d = useState(null), newPublisherOption = _d[0], setNewPublisherOption = _d[1];
    var _e = useState(false), errorModalOpen = _e[0], setErrorModalOpen = _e[1];
    var _f = useState(""), errorMessage = _f[0], setErrorMessage = _f[1];
    var titleVerificationSchema = createTitleVerificationSchema(formatMessage);
    var _g = useForm({
        resolver: zodResolver(titleVerificationSchema),
        shouldFocusError: false,
        defaultValues: {
            publisherId: initialValues.ownerId || "",
        },
        mode: "onBlur",
    }), handleSubmit = _g.handleSubmit, control = _g.control, setValue = _g.setValue, errors = _g.formState.errors;
    var _h = usePublishersData(publisherQuery, selectedPublisherId), publishers = _h.publishers, isPublishersLoading = _h.isPublishersLoading, selectedPublisher = _h.selectedPublisher;
    var publisherOptions = useMemo(function () {
        var entries = publishers.map(function (publisher) { return ({
            value: publisher.id || "",
            label: formatPublisherLabel(publisher),
        }); });
        var extra = newPublisherOption &&
            !entries.some(function (e) { return e.value === newPublisherOption.value; })
            ? newPublisherOption
            : (selectedPublisher === null || selectedPublisher === void 0 ? void 0 : selectedPublisher.id) &&
                (selectedPublisher === null || selectedPublisher === void 0 ? void 0 : selectedPublisher.name) &&
                !entries.some(function (e) { return e.value === selectedPublisher.id; })
                ? {
                    value: selectedPublisher.id,
                    label: formatPublisherLabel(selectedPublisher),
                }
                : null;
        return __spreadArray(__spreadArray([
            {
                value: "",
                label: formatMessage({
                    id: "ui-br-legaldeposits.collectionsList.select.option.all",
                }),
            }
        ], (extra ? [extra] : []), true), entries, true);
    }, [publishers, selectedPublisher, newPublisherOption, formatMessage]);
    var setPublisherId = function (publisherId, publisherName) {
        if (publisherName) {
            setNewPublisherOption({ value: publisherId, label: publisherName });
        }
        setValue("publisherId", publisherId);
        setSelectedPublisherId(publisherId);
    };
    var handleErrorModalClose = function () {
        setErrorModalOpen(false);
    };
    return {
        handleSubmit: handleSubmit,
        control: control,
        errors: errors,
        publisherOptions: publisherOptions,
        isPublishersLoading: isPublishersLoading,
        setPublisherQuery: setPublisherQuery,
        setPublisherId: setPublisherId,
        errorModalOpen: errorModalOpen,
        setErrorModalOpen: setErrorModalOpen,
        errorMessage: errorMessage,
        setErrorMessage: setErrorMessage,
        handleErrorModalClose: handleErrorModalClose,
    };
};
